<template>
  <div class="product-container">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-left">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/Welcome' }">
            <i class="el-icon-s-home"></i> 首页
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <i class="el-icon-goods"></i> 商城
          </el-breadcrumb-item>
          <el-breadcrumb-item>商品浏览</el-breadcrumb-item>
        </el-breadcrumb>
        
      </div>
    </div>

    <!-- 统计卡片 -->
    <div class="stats-row">
      <div class="stat-card">
        <div class="stat-icon icon-total">
          <i class="el-icon-s-goods"></i>
        </div>
        <div class="stat-info">
          <div class="stat-label">全部商品</div>
          <div class="stat-number">{{ total }}</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon icon-active">
          <i class="el-icon-sold-out"></i>
        </div>
        <div class="stat-info">
          <div class="stat-label">在售商品</div>
          <div class="stat-number">{{ onSaleCount }}</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon icon-inactive">
          <i class="el-icon-receiving"></i>
        </div>
        <div class="stat-info">
          <div class="stat-label">总库存</div>
          <div class="stat-number">{{ totalStock }}</div>
        </div>
      </div>
    </div>

    <!-- 搜索筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <div class="filter-header">
        <i class="el-icon-search filter-icon"></i>
        <span class="filter-title">筛选查询</span>
      </div>

      <el-form
        size="small"
        :inline="true"
        :model="searchForm"
        ref="searchFormRef"
        class="filter-form"
      >
        <div class="filter-row">
          <el-form-item label="商品名称">
            <el-input
              v-model="searchForm.name"
              placeholder="请输入商品名称"
              clearable
              prefix-icon="el-icon-search"
            ></el-input>
          </el-form-item>

          <el-form-item label="商品分类">
            <el-select
              v-model="searchForm.category"
              placeholder="请选择分类"
              clearable
              style="width: 180px;"
            >
              <el-option label="手机数码" value="数码"></el-option>
              <el-option label="家用电器" value="家电"></el-option>
              <el-option label="电脑办公" value="电脑"></el-option>
              <el-option label="家居日用" value="家居"></el-option>
              <el-option label="服饰鞋包" value="服饰"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="价格区间">
            <div class="price-range">
              <el-input
                v-model="searchForm.minPrice"
                placeholder="最低价"
                type="number"
                style="width: 100px;"
              ></el-input>
              <span class="separator">-</span>
              <el-input
                v-model="searchForm.maxPrice"
                placeholder="最高价"
                type="number"
                style="width: 100px;"
              ></el-input>
            </div>
          </el-form-item>

          <el-form-item class="action-buttons">
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="searchSubmit"
              class="search-btn"
            >
              搜索
            </el-button>
            <el-button
              icon="el-icon-refresh"
              @click="resetSearch"
              class="reset-btn"
            >
              重置
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-card>

    <!-- 数据表格区域（卡片式商品展示，符合商城风格） -->
    <el-card class="product-card" shadow="never">
      <div class="table-header">
        <div class="table-header-left">
          <i class="el-icon-s-data table-icon"></i>
          <span class="table-title">商品列表</span>
          <el-tag type="info" size="small" effect="plain">共 {{ total }} 件商品</el-tag>
        </div>
        <div class="table-header-right">
          <el-tooltip content="刷新数据" placement="top">
            <el-button
              icon="el-icon-refresh"
              size="small"
              circle
              @click="getList"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="按销量排序" placement="top">
            <el-button
              icon="el-icon-sort"
              size="small"
              circle
              @click="sortBySales"
            ></el-button>
          </el-tooltip>
        </div>
      </div>

      <!-- 商品卡片列表（更符合商城浏览习惯） -->
      <div class="product-list" v-loading="loading" element-loading-text="商品加载中...">
        <div
          v-for="item in tableData"
          :key="item.id"
          class="product-item"
          @click="goDetail(item)"
        >
          <div class="product-image">
            <img :src="item.image || defaultImage" :alt="item.name" />
          </div>
          <div class="product-info">
            <div class="product-name">{{ item.name }}</div>
            <div class="product-desc">{{ item.description || '暂无描述' }}</div>
            <div class="product-price">
              <span class="price-current">¥{{ item.price }}</span>
              <span class="price-original" v-if="item.originalPrice">¥{{ item.originalPrice }}</span>
            </div>
            <div class="product-meta">
              <span class="sales">月销 {{ item.sales || 0 }} 件</span>
              <span class="stock">库存 {{ item.stock }}</span>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-if="tableData.length === 0 && !loading" class="empty-state">
          <i class="el-icon-shopping-cart-empty"></i>
          <p>暂无商品数据</p>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination-container" v-if="total > 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[12, 24, 36, 48]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 商品详情弹窗 -->
    <el-dialog
      title="商品详情"
      :visible.sync="detailVisible"
      width="600px"
      class="alipay-dialog"
    >
      <div class="product-detail" v-if="detailData.id">
        <div class="detail-image">
          <img :src="detailData.image || defaultImage" :alt="detailData.name" />
        </div>
        <div class="detail-info">
          <h3>{{ detailData.name }}</h3>
          <div class="detail-price">
            <span class="price-label">价格</span>
            <span class="price-value">¥{{ detailData.price }}</span>
          </div>
          <div class="detail-stock">
            <span class="stock-label">库存</span>
            <span>{{ detailData.stock }} 件</span>
          </div>
          <div class="detail-sales">
            <span class="sales-label">月销量</span>
            <span>{{ detailData.sales || 0 }} 件</span>
          </div>
          <div class="detail-desc">
            <span class="desc-label">商品描述</span>
            <p>{{ detailData.description || '暂无描述' }}</p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// ---------- Mock 数据 ----------
// 模拟商品数据
const mockProducts = [
  { id: 1, name: 'iPhone 15 Pro Max', category: '数码', price: 9999, originalPrice: 10999, stock: 128, sales: 234, description: '苹果最新旗舰手机，A17芯片，钛金属边框', image: '', status: 1 },
  { id: 2, name: '小米14 Ultra', category: '数码', price: 6499, originalPrice: 6999, stock: 256, sales: 567, description: '徕卡光学镜头，骁龙8 Gen3', image: '', status: 1 },
  { id: 3, name: '华为Mate 60 Pro', category: '数码', price: 6999, originalPrice: 7999, stock: 89, sales: 1890, description: '卫星通话，鸿蒙系统', image: '', status: 1 },
  { id: 4, name: 'MacBook Pro 14', category: '电脑', price: 14999, originalPrice: 15999, stock: 45, sales: 89, description: 'M3芯片，16GB+512GB', image: '', status: 1 },
  { id: 5, name: '联想拯救者Y9000P', category: '电脑', price: 8999, originalPrice: 9999, stock: 120, sales: 345, description: 'i9-13900HX，RTX4060', image: '', status: 1 },
  { id: 6, name: '索尼WH-1000XM5', category: '数码', price: 1999, originalPrice: 2499, stock: 310, sales: 789, description: '降噪耳机，30小时续航', image: '', status: 1 },
  { id: 7, name: '小米空气净化器4 Pro', category: '家电', price: 1299, originalPrice: 1599, stock: 67, sales: 234, description: '除甲醛，除菌，智能控制', image: '', status: 1 },
  { id: 8, name: '戴森V15吸尘器', category: '家电', price: 4999, originalPrice: 5499, stock: 23, sales: 156, description: '激光探测，强劲吸力', image: '', status: 1 },
  { id: 9, name: '九阳破壁机', category: '家居', price: 599, originalPrice: 899, stock: 234, sales: 890, description: '一键清洗，低噪音', image: '', status: 1 },
  { id: 10, name: '李宁运动鞋', category: '服饰', price: 399, originalPrice: 599, stock: 567, sales: 1234, description: '轻便透气，缓震耐磨', image: '', status: 1 },
  { id: 11, name: 'Nike Air Force 1', category: '服饰', price: 799, originalPrice: 899, stock: 234, sales: 567, description: '经典板鞋，百搭款', image: '', status: 1 },
  { id: 12, name: '罗技MX Master 3S', category: '电脑', price: 699, originalPrice: 899, stock: 189, sales: 345, description: '静音鼠标，8000DPI', image: '', status: 1 },
]

const mockApi = {
  // 获取商品列表（分页+筛选）
  getProductList(params) {
    return new Promise((resolve) => {
      setTimeout(() => {
        let list = [...mockProducts]
        
        // 筛选
        if (params.name) {
          list = list.filter(item => item.name.includes(params.name))
        }
        if (params.category && params.category !== '') {
          list = list.filter(item => item.category === params.category)
        }
        if (params.minPrice !== '' && params.minPrice !== null && params.minPrice !== undefined) {
          list = list.filter(item => item.price >= Number(params.minPrice))
        }
        if (params.maxPrice !== '' && params.maxPrice !== null && params.maxPrice !== undefined) {
          list = list.filter(item => item.price <= Number(params.maxPrice))
        }
        
        // 排序（按销量降序）
        if (params.sortBySales) {
          list.sort((a, b) => (b.sales || 0) - (a.sales || 0))
        }
        
        const total = list.length
        const start = (params.pageNum - 1) * params.pageSize
        const data = list.slice(start, start + params.pageSize)
        
        // 统计数据
        const onSaleCount = mockProducts.filter(item => item.status === 1).length
        const totalStock = mockProducts.reduce((sum, item) => sum + (item.stock || 0), 0)
        
        resolve({ code: 200, data, total, onSaleCount, totalStock, msg: 'success' })
      }, 300)
    })
  }
}

export default {
  name: 'productList',
  data() {
    return {
      loading: false,
      searchForm: {
        name: '',
        category: '',
        minPrice: '',
        maxPrice: ''
      },
      tableData: [],
      pageNum: 1,
      pageSize: 12,
      total: 0,
      onSaleCount: 0,
      totalStock: 0,
      sortBySalesFlag: false,
      defaultImage: 'https://via.placeholder.com/200x200?text=No+Image',
      detailVisible: false,
      detailData: {}
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.searchForm,
          sortBySales: this.sortBySalesFlag
        }
        // 处理空值
        if (params.minPrice === '') params.minPrice = null
        if (params.maxPrice === '') params.maxPrice = null
        
        const res = await mockApi.getProductList(params)
        if (res.code === 200) {
          this.tableData = res.data
          this.total = res.total
          this.onSaleCount = res.onSaleCount
          this.totalStock = res.totalStock
        } else {
          this.$message.error(res.msg || '数据加载失败')
        }
      } catch (error) {
        console.error(error)
        this.$message.error('网络异常，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    
    searchSubmit() {
      this.pageNum = 1
      this.sortBySalesFlag = false
      this.getList()
    },
    
    resetSearch() {
      this.searchForm = {
        name: '',
        category: '',
        minPrice: '',
        maxPrice: ''
      }
      this.pageNum = 1
      this.sortBySalesFlag = false
      this.getList()
    },
    
    sortBySales() {
      this.sortBySalesFlag = !this.sortBySalesFlag
      this.pageNum = 1
      this.getList()
    },
    
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.getList()
    },
    
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.getList()
    },
    
    goDetail(row) {
      this.detailData = { ...row }
      this.detailVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
// 支付宝风格变量（与之前模块保持一致）
$primary-color: #1677ff;
$success-color: #00b42a;
$danger-color: #f53f3f;
$warning-color: #ff7d00;
$text-primary: #1f2d3d;
$text-regular: #4e5969;
$text-secondary: #86909c;
$border-color: #e5e6eb;
$bg-gray: #f7f8fa;
$card-shadow: 0 2px 8px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02);

.product-container {
  padding: 20px 24px;
  background: $bg-gray;
  min-height: calc(100vh - 84px);
}

/* 页面头部 */
.page-header {
  margin-bottom: 20px;
  .header-left {
    .el-breadcrumb {
      margin-bottom: 12px;
      ::v-deep .el-breadcrumb__item {
        .el-breadcrumb__inner {
          color: $text-secondary;
          font-size: 13px;
          &.is-link {
            color: $primary-color;
            &:hover { color: lighten($primary-color, 10%); }
          }
        }
        &:last-child .el-breadcrumb__inner {
          color: $text-primary;
          font-weight: 500;
        }
      }
    }
    .title-wrapper {
      display: flex;
      align-items: baseline;
      gap: 12px;
    }
    .page-title {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
      color: $text-primary;
      letter-spacing: -0.3px;
    }
    .badge-count {
      display: inline-block;
      padding: 2px 10px;
      background: rgba($primary-color, 0.1);
      color: $primary-color;
      border-radius: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.4;
    }
  }
}

/* 统计卡片 */
.stats-row {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  .stat-card {
    flex: 1;
    background: white;
    border-radius: 16px;
    padding: 20px 24px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-shadow: $card-shadow;
    transition: all 0.2s ease;
    border: 1px solid transparent;
    &:hover {
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
      border-color: rgba($primary-color, 0.1);
    }
    .stat-icon {
      width: 48px;
      height: 48px;
      border-radius: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      &.icon-total { background: rgba($primary-color, 0.1); color: $primary-color; }
      &.icon-active { background: rgba($success-color, 0.1); color: $success-color; }
      &.icon-inactive { background: rgba($warning-color, 0.1); color: $warning-color; }
    }
    .stat-info {
      flex: 1;
      .stat-label { font-size: 13px; color: $text-secondary; margin-bottom: 4px; }
      .stat-number { font-size: 28px; font-weight: 600; color: $text-primary; line-height: 1.2; }
    }
  }
}

/* 筛选卡片 */
.filter-card {
  margin-bottom: 20px;
  border-radius: 16px;
  border: none;
  box-shadow: $card-shadow;
  ::v-deep .el-card__body { padding: 20px 24px; }
  .filter-header {
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid $border-color;
    .filter-icon { color: $primary-color; font-size: 18px; margin-right: 8px; }
    .filter-title { font-size: 15px; font-weight: 600; color: $text-primary; }
  }
  .filter-form {
    .filter-row {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      align-items: flex-end;
    }
    ::v-deep .el-form-item {
      margin-bottom: 0;
      .el-form-item__label { font-weight: 500; color: $text-regular; font-size: 13px; }
      .el-input__inner, .el-select .el-input__inner {
        border-radius: 8px;
        border-color: $border-color;
        &:focus {
          border-color: $primary-color;
          box-shadow: 0 0 0 2px rgba($primary-color, 0.1);
        }
      }
    }
    .price-range {
      display: flex;
      align-items: center;
      gap: 8px;
      .separator { color: $text-secondary; }
    }
    .action-buttons {
      margin-left: auto;
      .search-btn, .reset-btn {
        border-radius: 20px;
        padding: 8px 20px;
        font-weight: 500;
      }
      .search-btn { background: $primary-color; border: none; &:hover { background: lighten($primary-color, 8%); } }
      .reset-btn { border-color: $border-color; color: $text-regular; &:hover { border-color: $primary-color; color: $primary-color; } }
    }
  }
}

/* 商品卡片区域 */
.product-card {
  border-radius: 16px;
  border: none;
  box-shadow: $card-shadow;
  ::v-deep .el-card__body { padding: 20px 24px; }
  
  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid $border-color;
    .table-header-left {
      display: flex;
      align-items: center;
      gap: 12px;
      .table-icon { color: $primary-color; font-size: 18px; }
      .table-title { font-size: 16px; font-weight: 600; color: $text-primary; }
      ::v-deep .el-tag { background: $bg-gray; border: none; color: $text-secondary; }
    }
    .table-header-right .el-button {
      color: $text-secondary;
      &:hover { color: $primary-color; background: rgba($primary-color, 0.05); }
    }
  }
}

/* 商品列表网格布局 */
.product-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
  
  .product-item {
    background: white;
    border-radius: 16px;
    overflow: hidden;
    transition: all 0.3s ease;
    cursor: pointer;
    border: 1px solid $border-color;
    
    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
      border-color: transparent;
    }
    
    .product-image {
      height: 200px;
      overflow: hidden;
      background: #f5f5f5;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s;
      }
      &:hover img {
        transform: scale(1.05);
      }
    }
    
    .product-info {
      padding: 16px;
      
      .product-name {
        font-size: 16px;
        font-weight: 600;
        color: $text-primary;
        margin-bottom: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      
      .product-desc {
        font-size: 12px;
        color: $text-secondary;
        margin-bottom: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        line-height: 1.4;
        height: 34px;
      }
      
      .product-price {
        margin-bottom: 8px;
        .price-current {
          font-size: 20px;
          font-weight: 600;
          color: $danger-color;
        }
        .price-original {
          font-size: 13px;
          color: $text-secondary;
          text-decoration: line-through;
          margin-left: 8px;
        }
      }
      
      .product-meta {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: $text-secondary;
        .sales, .stock {
          i { margin-right: 4px; }
        }
      }
    }
  }
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: $text-secondary;
  i { font-size: 64px; }
  p { margin-top: 16px; font-size: 14px; }
}

/* 分页 */
.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  margin-top: 16px;
  border-top: 1px solid $border-color;
  ::v-deep .el-pagination {
    .el-pagination__total, .el-pagination__jump { color: $text-secondary; font-size: 13px; }
    .btn-prev, .btn-next, .el-pager li { border-radius: 8px; margin: 0 4px; font-weight: 500; &:hover { color: $primary-color; } }
    .el-pager li.active { background: $primary-color; color: white; &:hover { background: lighten($primary-color, 8%); } }
    .el-select .el-input__inner { border-radius: 8px; }
  }
}

/* 详情弹窗 */
::v-deep .alipay-dialog {
  .el-dialog {
    border-radius: 20px;
    overflow: hidden;
    .el-dialog__header { border-bottom: 1px solid $border-color; padding: 20px 24px; .el-dialog__title { font-size: 18px; font-weight: 600; } }
    .el-dialog__body { padding: 24px; }
    .el-dialog__footer { border-top: 1px solid $border-color; padding: 16px 24px; }
  }
}

.product-detail {
  display: flex;
  gap: 24px;
  .detail-image {
    width: 200px;
    flex-shrink: 0;
    img {
      width: 100%;
      border-radius: 12px;
    }
  }
  .detail-info {
    flex: 1;
    h3 { margin: 0 0 16px 0; font-size: 18px; color: $text-primary; }
    .detail-price, .detail-stock, .detail-sales {
      margin-bottom: 12px;
      .price-label, .stock-label, .sales-label {
        display: inline-block;
        width: 80px;
        color: $text-secondary;
      }
      .price-value { font-size: 24px; font-weight: 600; color: $danger-color; }
    }
    .detail-desc {
      margin-top: 16px;
      .desc-label { display: block; color: $text-secondary; margin-bottom: 8px; }
      p { margin: 0; color: $text-regular; line-height: 1.6; }
    }
  }
}

/* 响应式 */
@media (max-width: 1200px) {
  .stats-row { flex-direction: column; gap: 12px; .stat-card { padding: 16px 20px; } }
  .filter-form .filter-row {
    flex-direction: column;
    align-items: stretch;
    .el-form-item { width: 100%; }
    .price-range { .el-input { width: 100% !important; } }
    .action-buttons { margin-left: 0; display: flex; gap: 12px; .el-button { flex: 1; text-align: center; } }
  }
  .product-list { grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); }
}

@media (max-width: 768px) {
  .product-container { padding: 16px; }
  .product-card ::v-deep .el-card__body { padding: 16px; }
  .product-list { grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); }
  .product-detail { flex-direction: column; align-items: center; text-align: center; .detail-info { width: 100%; } }
}
</style>